import { useToast as useChakraToast, UseToastOptions } from '@chakra-ui/react';

type Options = Partial<UseToastOptions> & {
    title: string;
};

export const defaultOptions: UseToastOptions = {
    duration: 3000,
    isClosable: true,
    position: 'top'
};

export default function useToast() {
    const toast = useChakraToast();

    const showSuccessToast = (options: Options) =>
        toast({
            status: 'success',
            ...defaultOptions,
            ...options
        });

    const showErrorToast = (options: Options) =>
        toast({
            status: 'error',
            ...defaultOptions,
            ...options
        });

    const showInfoToast = (options: Options) =>
        toast({
            status: 'info',
            ...defaultOptions,
            ...options
        });

    return { showSuccessToast, showErrorToast, showInfoToast };
}
